module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-template __donate __limited-edu __limited-edu--custom2021 __uob-limitededucation-2025"
  }, [_c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('div', {
    staticClass: "col-md-push-1 col-md-10 box"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "product-custom-title text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.product.meta.product_custom_title)
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('div', {
    staticClass: "col-md-push-1 col-md-10"
  }, [_c('div', {
    staticClass: "product product--inline"
  }, [_c('div', {
    staticClass: "product__block--form"
  }, [_c('div', {
    staticClass: "radius block shadow"
  }, [_c('product-donate-choice', {
    ref: "donateChoice",
    attrs: {
      "show-donate-type": true,
      "product": _vm.product,
      "classes": "col-1-5"
    },
    model: {
      value: (_vm.product.price),
      callback: function($$v) {
        _vm.$set(_vm.product, "price", $$v)
      },
      expression: "product.price"
    }
  }), _vm._v(" "), (_vm.product.price > 0) ? _c('div', {
    staticClass: "sumary-amount mb-15"
  }, [_c('table', {
    staticClass: "sumary-amount-detail"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "first-row"
  }, [_vm._v("ใช้ไป")]), _vm._v(" "), _c('td', {
    staticClass: "first-row text-right"
  }, [_c('strong', [_c('span', [_vm._v(_vm._s(_vm.totalProductPrice))]), _vm._v(" / " + _vm._s(_vm.product.price) + " บาท")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("จำนวนของ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.selectedProductCount) + " ชิ้น")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form__wrapper mt-15 mb-15 _clearboth"
  }, [_c('div', {
    staticClass: "form__section"
  }, [_c('label', {
    staticClass: "form__radio-lg"
  }, [_vm._v("\n                  ไม่ต้องการรับของ\n                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardProduct),
      expression: "attributes.info.rewardProduct"
    }],
    attrs: {
      "type": "radio",
      "name": "optionsRadios",
      "value": ""
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardProduct, "")
    },
    on: {
      "click": _vm.clearSelectedProducts,
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardProduct", "")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _vm._l((_vm.customProducts), function(p, i) {
    return _c('div', {
      key: i,
      staticClass: "form__section"
    }, [_c('label', {
      staticClass: "form__radio-lg",
      class: {
        disable: !_vm.canSelectReward(p)
      }
    }, [_vm._v("\n                  รับ" + _vm._s(p.title) + " "), _c('span', [_vm._v(_vm._s(p.price) + " บาท")]), _c('br'), _vm._v(" "), (p.description) ? _c('div', {
      staticClass: "product-option-description"
    }, [_vm._v(_vm._s(p.description))]) : _vm._e(), _vm._v(" "), (p.title === _vm.attributes.info.rewardProduct && _vm.error.rewardConfigSize) ? _c('div', {
      ref: "error",
      refInFor: true,
      staticClass: "alert alert--error mt-5"
    }, [_vm._v("\n                    " + _vm._s(_vm.error.rewardConfigSize) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.attributes.info.rewardProduct),
        expression: "attributes.info.rewardProduct"
      }],
      attrs: {
        "type": "radio",
        "name": "optionsRadios",
        "disabled": !_vm.canSelectReward(p)
      },
      domProps: {
        "value": p.title,
        "checked": _vm._q(_vm.attributes.info.rewardProduct, p.title)
      },
      on: {
        "click": _vm.onClickSelectReward,
        "change": function($event) {
          return _vm.$set(_vm.attributes.info, "rewardProduct", p.title)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkmark"
    })]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "slide-down"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (p.title === _vm.attributes.info.rewardProduct),
        expression: "p.title === attributes.info.rewardProduct"
      }],
      staticClass: "product-variation--wrapper slide-down-wrapper",
      class: {
        disable: !_vm.canSelectReward(p)
      }
    }, _vm._l((p.variations), function(variation) {
      return _c('div', {
        key: variation.title,
        staticClass: "product-variation--column",
        class: {
          'product-variation--column-full': p.variations.length === 1
        }
      }, [_c('div', {
        staticClass: "product-variation--item",
        class: {
          selected: _vm.selectedProducts[variation.value].quantity > 0
        }
      }, [_c('div', {
        staticClass: "mb-10"
      }, [_c('strong', [_vm._v(_vm._s(variation.title))])]), _vm._v(" "), _c('Thumbnail', {
        attrs: {
          "images": variation.images
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "product-quantity--wrapper"
      }, [_c('div', {
        staticClass: "product-quantity--title"
      }, [_vm._v("เลือกจำนวน")]), _vm._v(" "), _c('div', {
        staticClass: "product-quantity--control"
      }, [_c('button', {
        staticClass: "product-quantity--button",
        attrs: {
          "disabled": _vm.selectedProducts[variation.value].quantity === 0
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.decreaseProductQuantity(variation.value)
          }
        }
      }, [_vm._v("\n                              -\n                            ")]), _vm._v(" "), _c('span', {
        staticClass: "product-quantity--quantity"
      }, [_vm._v(_vm._s(_vm.selectedProducts[variation.value].quantity))]), _vm._v(" "), _c('button', {
        staticClass: "product-quantity--button",
        attrs: {
          "disabled": _vm.totalProductPrice + p.price > _vm.product.price
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.increaseProductQuantity(variation.value)
          }
        }
      }, [_vm._v("\n                              +\n                            ")])])])], 1)])
    }), 0)])], 1)
  })], 2), _vm._v(" "), _c('page-selector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.attributes.page),
      callback: function($$v) {
        _vm.$set(_vm.attributes, "page", $$v)
      },
      expression: "attributes.page"
    }
  }), _vm._v(" "), _c('product-cart-action', {
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "product": _vm.product,
      "attributes": _vm.attributes,
      "initialQuantity": 1,
      "addToCartButton": false,
      "buyNowButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "alert alert--warning"
  }, [_vm._v("โปรดตรวจสอบข้อมูลให้ถูกต้องก่อนกดปุ่มสั่งของที่ระลึก")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--purple btn--default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.donate.apply(null, arguments)
      }
    }
  }, [_vm._v("กดเพื่อบริจาค/ชำระเงิน")])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "text-center mb-20 flex align-items-center justify-content-center",
    attrs: {
      "data-v-1f20e9ef": ""
    }
  }, [_c('img', {
    staticClass: "logo-heartbeat",
    attrs: {
      "src": "/static/img/uob/uob-limitededucation-2025@2x.png",
      "srcset": "/static/img/uob/uob-limitededucation-2025@2x.png",
      "width": "240px",
      "alt": "TCFE x UOB"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center text-white heading"
  }, [_vm._v("ร่วมเป็นส่วนหนึ่งในการเปิดประตูสู่โอกาสทางการศึกษาให้กับเยาวชนที่ขาดโอกาส"), _c('br'), _vm._v("ด้วยการบริจาคพร้อมรับของที่ระลึกพิเศษรุ่น 'Let Me Shine'")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-462c1402","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/products/uob-limitededucation-2025-public.vue
// module id = 1145
// module chunks = 0